import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ObjectsGroupsService } from '@services/objects-groups.service';
import {
  loadObjectGroups,
  loadObjectGroupsFailure,
  loadObjectGroupsSuccess,
} from '@store/actions/object-groups.actions';

@Injectable()
export class ObjectGroupsEffects {
  private readonly actions$ = inject(Actions);
  private readonly objectGroupsService = inject(ObjectsGroupsService);

  loadObjectGroups$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadObjectGroups),
      mergeMap(() =>
        this.objectGroupsService.list().pipe(
          map((groups) => loadObjectGroupsSuccess({ list: groups })),
          catchError((error) => of(loadObjectGroupsFailure({ error: error.message }))),
        ),
      ),
    ),
  );
}
